import { useLang } from '@/context/LanguageContext';
import { motion } from 'framer-motion';
import { Paintbrush, Code, Palette, Layout } from 'lucide-react';

const icons = [Paintbrush, Code, Palette, Layout];

export default function Services() {
  const { t } = useLang();
  const items = t('services.items') || [];

  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {t('services.label') && t('services.label') !== 'services.label' && (
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4"
        >
          {t('services.label')}
        </motion.p>
        )}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-5xl lg:text-6xl font-normal tracking-normal text-purple-400 mb-16"
          style={{ fontFamily: "'Great Vibes', cursive" }}
        >
          {t('services.title')}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
          {items.map((item, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                data-testid={`service-card-${i}`}
                className="group bg-zinc-950 p-8 lg:p-12 hover:bg-zinc-900 transition-colors duration-500"
              >
                <div className="flex items-start justify-between mb-8">
                  <Icon size={32} className="text-zinc-600 group-hover:text-zinc-50 transition-colors duration-500" />
                  <span className="font-outfit text-5xl lg:text-6xl font-black text-zinc-900 group-hover:text-zinc-800 transition-colors">
                    {item.num}
                  </span>
                </div>
                <h3 className="text-2xl lg:text-3xl font-semibold tracking-tight text-purple-400 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {item.title}
                </h3>
                <p className="text-base font-manrope text-zinc-400 leading-relaxed">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
